var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1322 920",
    style: {
      enableBackground: "new 0 0 1322 920"
    },
    fill: "none",
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1310.07 413.445C1316.71 406.805 1330.01 382.886 1315.41 380.227C1300.81 377.567 1261.02 446.552 1247.08 436.601C1233.15 426.651 1306.13 312.581 1274.95 297.329C1255.98 288.048 1236.05 302.388 1217.19 315.296C1196 329.766 1176.94 342.712 1177.38 323.945C1177.61 314.701 1237.11 255.071 1186.03 219.249C1157.72 199.385 1105.86 229.274 1056.23 258.177C1016.35 281.408 974.273 311.037 933.329 285.704C872.705 248.208 887.903 3.08637 711.592 -4L0 -4V792.873C0 792.873 235.105 938.99 438.5 917.898C641.896 896.807 839.835 670.359 865.878 651.834C904.812 624.139 939.338 636.024 921.257 675.195C903.175 714.365 931.264 747.807 986.159 711.538C1085.68 645.789 1162.8 367.319 1238.92 348.477C1256.46 344.125 1189.05 469.318 1234.56 467.16C1254.92 466.193 1301.53 398.882 1306.31 395.422C1323.87 382.719 1307.67 412.441 1307.67 412.441L1310.11 413.408L1310.07 413.445Z",
    fill: "#F2F2FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/header-background.99758e781f59d3aa6463caf2d1278a7f.svg";
export { ForwardRef as ReactComponent };